<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import { clientSettings, customerSettings } from '../../../stores/api';
    import SettingsRow from './SettingsRow.svelte';
    import { SettingsApi } from './SettingsApi';
    import { api } from '../../../stores/api';
    import Separator from '../../shared/Separator.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { features, fm } from '../../shared/Features/features';
    import SettingsRowNumber from './SettingsRowNumber.svelte';
    import { vehiclesManager } from '../Vehicles/VehiclesApp/vehiclesManager';
    import { app } from '../../../stores/app';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import Label from '../../shared/Label.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import ButtonSmallDanger from '../../shared/ButtonSmallDanger.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import Switch from '../../shared/Switch.svelte';
    import { debug } from '../../../stores/store';

    export let updateClient: () => void;
    export let allowToResetData: boolean = false;

    let error: string = '';
    let resetInProgress: boolean = false;
    let resetDone: boolean = false;
    let showTemplateData: boolean = false;

    async function prepareReset() {
        const shouldReset = confirm($_('confirm_reset_data'));
        if (shouldReset) {
            resetInProgress = true;
            try {
                await SettingsApi.resetData($api);
                await $vehiclesManager.triggerReload();
                resetInProgress = false;
                resetDone = true;
                console.info('Reset done'); // used in e2e tests
            } catch (error) {
                console.error('Reset failed:', error);
                alert($_('reset_data_failed'));
            }
        }
    }

    async function prepareCreateTemplate() {
        const shouldCreateTemplate = confirm($_('confirm_create_template'));
        if (shouldCreateTemplate) {
            await createTemplate();
        }
    }

    async function createTemplate() {
        try {
            $customerSettings.admin.template_data = await SettingsApi.createTemplate($api);
            $customerSettings = $customerSettings; // hack, żeby mieć pewność, że się widok odświeży
        } catch (error) {
            console.error('Reset failed:', error);
            alert($_('reset_data_failed'));
        }
    }
</script>

<TemplateSettingsGeneral>
    <div slot="label">Admin</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>{$_('point_clustering')}</SettingsRowLabel>
            <SettingsRowValue>
                <SettingsRowNumber
                    bind:value={$clientSettings.display.point_cluster_distance}
                    annotation=""
                    update={updateClient}
                    validator={data => z.coerce.number().int().min(50).max(200).safeParse(data)}
                />
            </SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>
                {$_('Simulate moving vehicles on the map (feature 1360) - nieaktywny ze względu na zaznaczanie zleceń jako wykonanych')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Checkbox
                    bind:checked={$features.feature_1360_track_vehicles_random}
                    disabled={true}
                    label=""
                    onChange={s => {
                        if (!$features.feature_1360_track_vehicles) {
                            $features.feature_1360_track_vehicles = true;
                            alert($_('feature_track_vehicles_auto_enabled'));
                        }
                        $fm = $fm;
                        return true;
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>

        <Separator />

        <div class="settings-group" class:error={error !== ''}>
            <SettingsRow>
                <SettingsRowLabel>{$_('reset_view')}</SettingsRowLabel>
                <SettingsRowValue>
                    {#if resetInProgress}
                        <IconPending scale={0.7} spin={true} />
                    {:else if resetDone}
                        <Label>OK</Label>
                    {:else}
                        <ButtonSmallDanger
                            disabled={!allowToResetData}
                            text={$_('reset_view_button')}
                            on:click={prepareReset}
                        />
                    {/if}
                </SettingsRowValue>
            </SettingsRow>
            <Separator />
            {#if $customerSettings && $customerSettings.admin && $customerSettings.admin.template_data}
                <SettingsRow>
                    <SettingsRowLabel>{$_('template_login_data')}</SettingsRowLabel>
                    <SettingsRowValue>
                        {#if !showTemplateData}
                            <LinkSmallBlack
                                text={$_('show_login_password')}
                                on:click={() => {
                                    showTemplateData = !showTemplateData;
                                }}
                            ></LinkSmallBlack>
                        {:else}
                            <input
                                type="text"
                                value={$customerSettings.admin.template_data}
                                disabled
                                style="min-width: 250px;font-size: 12px;text-align: center;font-weight: bold;overflow: visible;border: 0;background: #0000;color: #1b5abf;cursor: text;"
                            />
                        {/if}
                    </SettingsRowValue>
                </SettingsRow>
            {:else}
                <SettingsRow>
                    <SettingsRowLabel>{$_('create_own_template')}</SettingsRowLabel>
                    <SettingsRowValue>
                        <ButtonSmallBlack
                            disabled={resetInProgress}
                            text={$_('create_button')}
                            on:click={prepareCreateTemplate}
                        />
                    </SettingsRowValue>
                </SettingsRow>
            {/if}
        </div>

        <SettingsRow>
            <SettingsRowLabel>CustomerId</SettingsRowLabel>
            <SettingsRowValue>{$app.account.getCustomerId()}</SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>WebuserId</SettingsRowLabel>
            <SettingsRowValue>{$app.account.getWebuserId()}</SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>{$_('readonly_mode_webuser')}</SettingsRowLabel>
            <SettingsRowValue>
                {#if $clientSettings.display.readonlyMode}
                    <Label>{$_('readonly_mode_set_warning')}</Label>
                    <!-- webuser_id weź z SELECT customer_id, webuser_id, comment from lm_user where customer_id=84;

                    POKAZ STATUS READONLY:
        SELECT webuser_id, settings->'settings'->'display'->'readonlyMode' AS readonly_mode, settings::jsonb as settings FROM user_settings WHERE webuser_id IN (10536949,11051955,46300947,48609026,51966499,63322933,63386219,63386220,63386221,63386222,63386223,63386224,63386225,63386226,63386227,63386230,63386231,63392376,63619355)

                    DODAJ NOWE REKORDY:
        INSERT INTO user_settings (webuser_id, settings) VALUES (11111111111111, '{"settings":{"display": {"readonlyMode": true}}}'::jsonb);

                    AKTUALIZUJ ISTNIEJĄCE REKORDY:

-- 10536949,11051955,46300947,48609026,51966499,63322933,63386219,63386220,63386221,63386222,63386223,63386224,63386225,63386226,63386227,63386230,63386231,63392376,63619355

UPDATE user_settings
SET settings = jsonb_set(
    COALESCE(settings, '{}'::jsonb),
    '{settings,display,readonlyMode}',
    'true'::jsonb,
    true
)
WHERE webuser_id IN (
    11051955
);

-- SHOW COMPLEX READONLY STATUS
SELECT
    lu.customer_id,
    lu.webuser_id,
    lu.comment,
    us.settings->'settings'->'display'->>'readonlyMode' AS readonly_mode
FROM lm_user lu
         LEFT JOIN user_settings us
                   ON us.webuser_id = lu.webuser_id
WHERE lu.customer_id = 84;
                    -->
                {:else}
                    <ButtonSmallDanger
                        disabled={false}
                        text={$_('set_readonly')}
                        on:click={() => {
                            if (confirm($_('confirm_set_readonly'))) {
                                $clientSettings.display.readonlyMode = true;
                                updateClient();
                            }
                        }}
                    />
                {/if}
            </SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>Email</SettingsRowLabel>
            <SettingsRowValue>{$app.account.getEmail()}</SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>Name</SettingsRowLabel>
            <SettingsRowValue>{$app.account.getName()}</SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>Enabled map layers</SettingsRowLabel>
            <SettingsRowValue>{$app.account.getEnabledMapLayers().join(', ')}</SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>Debug mode (tech details - Ctrl+F1)</SettingsRowLabel>
            <SettingsRowValue>
                <Switch
                    checked={$debug}
                    on:change={checked => {
                        console.log('checked', checked);
                        debug.set(checked?.detail?.checked);
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
